import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { toggle_off, toggle_on } from "../../assets/img";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const ReceptionistOnOff = () => {
  const [selected, setSelected] = useState(false);

  const fetchData = async () => {
    let res = await get(URLS.RECEPTIONIST_TURN_ON_OFF);
    // console.log("erecepRes", res);
    if (res?.status === "success") {
      setSelected(res?.data?.status);
    }
  };

  const handleSubmit = async () => {
    let res = await post(URLS.RECEPTIONIST_TURN_ON_OFF, { status: selected });
    if (res?.status === "success") {
      toast.success(res?.message);
      fetchData();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="row mt-4">
        <div className="col-12 col-md-8 col-lg-5">
          <div className="card border-0 shadow-sm rounded-4">
            <div className="card-body p-4">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h5 className="fw-semibold mb-1">Receptionist Service</h5>
                  <p className="text-muted small mb-0">
                    Toggle this button to switch between on and off
                  </p>
                </div>
                <span
                  className={`badge rounded-pill px-3 py-2 ${
                    selected
                      ? "bg-success-subtle text-success"
                      : "bg-danger-subtle text-danger"
                  }`}
                >
                  {selected ? "ON" : "OFF"}
                </span>
              </div>

              <hr className="text-muted" />

              {/* Toggle row */}
              <div
                className={`d-flex justify-content-between align-items-center rounded-3 p-3 mb-4 ${
                  selected ? "bg-success-subtle" : "bg-light"
                }`}
                style={{ transition: "background-color .2s ease" }}
              >
                <div className="fw-medium">
                  {selected ? "Receptionist is ON" : "Receptionist is OFF"}
                </div>
                <img
                  src={selected ? toggle_on : toggle_off}
                  className="roles-icon pointer"
                  alt=""
                  onClick={() => {
                    setSelected((prev) => !prev);
                  }}
                />
              </div>

              {/* Action */}
              <div className="d-flex justify-content-start">
                <button
                  type="button"
                  className="submit-btn px-4"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceptionistOnOff;
